import { borders } from 'src/theme/adSales/borders'

import type { ThemeUIStyleObject } from 'theme-ui'

const primary: ThemeUIStyleObject = {
  '.react-tabs': {
    '&__tab-list': {
      maxWidth: 'layoutPlus',
      maxHeight: '48px',
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      flexWrap: 'nowrap',
      gap: [null, null, 2, 4],
      pl: [4]
    },
    '&__tab': {
      display: 'inline-block',
      width: 'auto',
      maxWidth: '170px',
      maxHeight: '48px',
      p: [2, null, null, null, 3],
      position: 'relative',
      listStyle: 'none',
      cursor: 'pointer',
      '& p': {
        display: 'inherit',
        justifyContent: 'center',
        color: 'text.primary',
        mb: 2
      },
      '& span': {
        color: 'text.primary'
      },
      '&:hover': {
        borderBottom: borders.hoverPageTab
      },
      '&--selected': {
        borderBottom: borders.hoverPageSelected,
        '&:hover': {
          borderBottom: borders.hoverPageSelected
        }
      },
      '&--disabled': {
        color: 'GrayText',
        cursor: 'default'
      }
    },
    '&__tab-panel': {
      display: 'none',
      '&--selected': {
        display: 'block',
        bg: 'neutrals.200',
        minHeight: '400px'
      }
    }
  }
}

export const pageTabs = {
  primary
}
